import Slider from 'react-slick';
import React, { useEffect, useState } from 'react';

import AdBannerCard from '../../Ads/view/AdBannerCard';
import { getUserId } from '../../../helpers/storage/user';
import { AdCampaignPlacementType } from '../../../helpers/constants/ads';
import AdCampaignService from '../../../helpers/services/ads/ad-campaigns';

const settings = {
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  vertical: false,
  verticalSwiping: false,
  swipeToSlide: true,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const BannerAds = () => {
  const [records, setRecords] = useState([]);

  useEffect(() => {
    fetchRecords();
  }, [])

  const fetchRecords = async () => {
    try {
      const data = await AdCampaignService.fetchRecommended({
        limit: 3,
        user_id: getUserId(),
        placement: AdCampaignPlacementType.LANDING_PAGE_SPONSORED_HIGHLIGHT,
      });
      setRecords(data?.ads);
    } catch (error) {
      console.error('Fetching ads error', error);
    }
  };

  if (records.length === 0) return <></>
  return (
    <div className='introduction-main ads-container px-0 px-md-3 mb-0'>
      <div className='container'>
        <div className='heading-box text-center'>
          <div className='section-title'>FEATURED MOMENTS</div>
          <h2 className='heading-title'>Sponsored Highlights From Our Community</h2>
        </div>
        <div className='suggestion-slider'>
          <Slider {...settings}>
            {records.map((ads, index) => {
              return (
                <AdBannerCard key={ads?.id || `ad-${index}`} data={ads} />
              );
            })
            }
          </Slider>
        </div>
      </div>
    </div>
  )
};

BannerAds.propTypes = {
};

export default BannerAds;
